<template>
	<roles :breadcrumbs="breadcrumbArray" :note="'Create and manage your business roles.'" :businessId="activeBusinessId" :baseRoute="'/app/my_business/roles'" :baseRouteName="'My Business Roles'"></roles>
</template>
<script>
import Roles from '../Roles/Roles'
import { mapGetters } from 'vuex'

/**
 * My Business Roles module is a page for the roles dashboard and creation process for the current business.
 * @class MyBusinessRoles
 * @since 0.0.8
 */

export default {
	data () {
		return {
			breadcrumbArray: [
				{name: 'My Business', link: false},
				{name: 'Roles', link: false}
			]
		}
	},
	computed: mapGetters([
		'activeBusinessId'
	]),
	components: {
		Roles
	}
}
</script>


// WEBPACK FOOTER //
// Roles.vue?9cf946a2